import * as React from 'react';
import { Transition } from 'react-transition-group';

import { styles } from './styles';
import { animations } from './animations';
import { ExitHandler, TransitionProps } from 'react-transition-group/Transition';

export type Direction = 'left' | 'right';

export type As = 'state' | 'css';
export type Position = 'absolute' | 'relative';
export interface Props {
  in?: boolean;
  as: As;
  appear?: boolean;
  from: Direction;
  to: Direction;
  onExited?: ExitHandler;
  timeout?: TransitionProps['timeout'];
  enter?: TransitionProps['enter'];
  exit?: TransitionProps['exit'];
  mountOnEnter?: TransitionProps['mountOnEnter'];
  unmounOnExit?: TransitionProps['unmountOnExit'];
  position?: Position;
}

class SlideInHorizontal extends React.PureComponent<Props> {
  render() {
    const { from, in: inProp, as: asProp, children, timeout, appear = true, unmounOnExit, mountOnEnter } = this.props;
    const animationStates = animations.getAnimationStates(from);

    if (asProp === 'css') {
      return <div className={styles.container(asProp, from, this.props.position)}>{children}</div>;
    }

    return (
      <Transition
        in={inProp}
        appear={appear}
        mountOnEnter={mountOnEnter}
        unmountOnExit={unmounOnExit}
        enter={this.props.enter}
        onEnter={node => node.scrollTop}
        exit={this.props.exit}
        timeout={timeout || { enter: 550, exit: 550 }}
        onExited={node => {
          if (this.props.onExited) {
            this.props.onExited(node);
          }
        }}
      >
        {state => {
          return (
            <div className={styles.container(asProp, from)} style={animationStates[state]}>
              {children}
            </div>
          );
        }}
      </Transition>
    );
  }

  static defaultProps = {
    as: 'state' as As,
    from: 'left' as Direction,
    to: 'left' as Direction,
    position: 'relative'
  };
}

export { SlideInHorizontal };
